export default __webpack_public_path__ + "static/media/member.53ea6fbd.svg";